import { useState } from 'react';
import MobileStep from './MobileStep';
import OtpStep from './OtpStep';

const LoginForm = () => {
  const [step, setStep] = useState('mobile');
  const [mobile, setMobile] = useState('');

  const handleOtpSent = (mobileNumber) => {
    setMobile(mobileNumber);
    setStep('otp');
  };

  const handleBack = () => {
    setMobile('');
    setStep('mobile');
  };

  if (step === 'otp' && mobile) {
    return <OtpStep mobile={mobile} onBack={handleBack} />;
  }

  return <MobileStep onSuccess={handleOtpSent} />;
};

export default LoginForm;
